export const loadedType = (state) => state.reducerManager.loadedType;
export const isTypeLoaded = (state, type) =>
  type
    ? state.reducerManager.loadedType === type
    : !!state.reducerManager.loadedType;
